import React from 'react';
import PropTypes from 'prop-types';
import DatePicker from '../date-picker/DatePicker';
import { errorStyle } from './styles';

const renderDatePicker = ({ meta: { visited, touched, invalid, error }, input, ...custom }) => (
  <React.Fragment>
    <DatePicker
      {...input}
      {...custom}
    />
    {(visited || touched || invalid) && (error && (
      <span style={errorStyle}>
        {error}
      </span>
    ))}
  </React.Fragment>
);

renderDatePicker.defaultProps = {
  input: null,
  meta: {
    visited: false,
    error: '',
    touched: false,
  },
};

renderDatePicker.propTypes = {
  input: PropTypes.shape({
    value: PropTypes.string,
    input: PropTypes.string,
  }),
  meta: PropTypes.shape({
    visited: PropTypes.bool,
    touched: PropTypes.bool,
    invalid: PropTypes.bool,
    error: PropTypes.string,
  }),
};

export default renderDatePicker;
